import React, { useEffect, useState } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { Col, Row, Form, Nav, Card, Button } from "react-bootstrap";
import Footer from "../layouts/Footer";
import useManageLabRequests from "../hooks/patientDashboard/usemanageLabrequests";
import Header from "../layouts/Header";
import DrugMart from "../dashboard/drugMart";
import PurchasedDrugs from "./PurchasedDrugs";
import MedicationsHistory from "./medicationsHistory";
import { useLab } from "../context/labContext";
import { useDrugs } from "../context/manageDrugs";

export default function MedicationTab() {
    const {handleFechLabRequests, handleFechLabRequestsAlt} = useManageLabRequests();
      const currentSkin = (localStorage.getItem('skin-mode')) ? 'dark' : '';
      const [skin, setSkin] = React.useState(currentSkin);
      const [tabs, setTabs] = useState('drug-mart');
      const { handleFetchDrugMart, drugMart, loading: loadingDrugs, handleFetchDrugs, drugs, handleQueryMart } = useDrugs();
      const {handleFetchPurchasedDrugs, purchasedDrugs,loading:loadingPurchasedDrugs} = useLab()

      useEffect(() => {
          handleFetchDrugMart()
          handleFetchDrugs()
          handleFechLabRequestsAlt()
          handleFetchPurchasedDrugs('drugs')
          handleFechLabRequests()
      },[])

      const switchSkin = (skin) => {
            if (skin === 'dark') {
            const btnWhite = document.getElementsByClassName('btn-white');
    
            for (const btn of btnWhite) {
                btn.classList.add('btn-outline-primary');
                btn.classList.remove('btn-white');
            }
            } else {
            const btnOutlinePrimary = document.getElementsByClassName('btn-outline-primary');
    
            for (const btn of btnOutlinePrimary) {
                btn.classList.remove('btn-outline-primary');
                btn.classList.add('btn-white');
            }
            }
      };
    
      switchSkin(skin);
      useEffect(() => {
        switchSkin(skin);
      }, [skin]);

   console.log(drugs,"================drugs")
 
    
    const location = useLocation();
    const navigate = useNavigate();
    
    useEffect(() => {
      if (location.hash) {
        setTabs(location.hash.replace("#", ""));
      } else {
        setTabs("drug-mart");
      }
    }, [location]);
    
    //  Update URL hash when switching tabs
    const handleTabChange = (tab) => {
      setTabs(tab);
      navigate(`#${tab}`);
    };
    
        
        

  return (
    <React.Fragment>
      <Header onSkin={setSkin} />
      {/* <HeaderMobile /> */}
      <div className="main  p-4 p-lg-5">
        <Row className="g-5">
          <Col xl>
         

            <Nav className="nav-line d-none d-lg-flex mt-5 flex-wrap mb-0 gap-0">
              <Button
                onClick={() => handleTabChange("drug-mart")}
                variant="link"
                className={`text-decoration-none ${
                  tabs === "drug-mart"
                    ? "border-0 border-bottom border-1 border-primary fw-bold"
                    : "border-0 text-muted"
                }`}
              >
                Drug Mart
              </Button>
  
              <Button
                onClick={() => handleTabChange("purchased-drugs")}
                variant="link"
                className={`text-decoration-none ${
                  tabs === "purchased-drugs"
                    ? "border-0 border-bottom border-1 border-primary fw-bold"
                    : "border-0 text-muted"
                }`}
              >
                Purchased Drugs
              </Button>
  
              <Button
                onClick={() => handleTabChange("medications-history")}
                variant="link"
                className={`text-decoration-none ${
                  tabs === "medications-history"
                    ? "border-0 border-bottom border-1 border-primary fw-bold"
                    : "border-0 text-muted"
                }`}
              >
                Medications History
              </Button>
            </Nav>
            

            <Row className="g-3">
              
              {/* <Card> */}
                {/* lab table */}

                <h2 className="h5 mb- p-2 border-bottom\"> </h2>
                {
                  tabs === 'drug-mart' &&(<DrugMart drugMart={drugMart} loading={loadingDrugs} handleQueryMart={handleQueryMart}/>)
                }
                {
                  tabs === 'purchased-drugs' &&(<PurchasedDrugs loading={loadingPurchasedDrugs} data={purchasedDrugs}/>)
                }
                {
                  tabs === 'medications-history' &&(<MedicationsHistory  drugs={drugs} handleFetchDrugs={handleFetchDrugs} loading={loadingDrugs} /> )
                }

              {/* </Card> */}
           </Row>
          </Col>
          {/* {
            tabs !== 'mart' && (
          <Col xl="3" className="d-none d-xl-block">
            <LabRequestHistorySidebar/>
          </Col>

            )
          } */}
        </Row>
        <Footer />
      </div>
    </React.Fragment>
  );
}
